import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild,} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxSliderModule, Options} from '@angular-slider/ngx-slider';
import {UserService} from '../../../../../services/user-services/user.service';
import {Location, NgClass, NgFor, NgIf} from '@angular/common';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute} from '@angular/router';
import {FunctionsUtil} from '../../../../../helpers/functions.util';
import {Property} from '../../../../../models/property';
import {TranslateModule} from '@ngx-translate/core';
import {MatRadioModule} from '@angular/material/radio';
import {FilterContentComponent} from './filter-content/filter-content.component';
import {NumberOnlyDirective} from '../../../../../directives/numberOnly.directive';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {IconComponent} from '../../../../../shared/components/icons-svgs/icons-svgs.component';
import {HelperService} from '../../../../../services/helper.service';
import {MatCheckbox} from '@angular/material/checkbox';
import {ShowMoreComponent} from "../../../../../shared/components/ux/show-more/show-more.component";

@Component({
  selector: 'app-component-filter-modal',
  templateUrl: './component-filter-modal.component.html',
  styleUrls: ['./component-filter-modal.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    IconComponent,
    FormsModule,
    ReactiveFormsModule,
    NgxSliderModule,
    NgxIntlTelInputModule,
    NumberOnlyDirective,
    FilterContentComponent,
    MatRadioModule,
    NgFor,
    TranslateModule,
    MatCheckbox,
    ShowMoreComponent,
  ],
})
export class ComponentFilterModalComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() readonly rooms: any[] = [];
  @Input() readonly searchCity;
  @Input() readonly favList: any[] = [];
  @Output() filteredRooms: EventEmitter<any> = new EventEmitter();
  @Output() private filterObj: EventEmitter<any> = new EventEmitter();
  public isMobile = false;
  public filteredRoomsArray: any[];
  public sortValue: string;
  public sortArray: { name: string, key: string }[] = [
    {name: 'priceAsc', key: 'PRICE_ASC'},
    {name: 'priceDesc', key: 'PRICE_DESC'},
    {name: 'newest', key: 'NEWEST'},
    {name: 'disponibility_close', key: 'DISPONIBILITY_CLOSE'},
    {name: 'disponibility_far', key: 'DISPONIBILITY_FAR'},
    {name: 'promotion', key: 'FILTER_PROMOTION'}
  ];
  public displayedFilter: string;
  public nbSubFilter = 0;
  public filters: any = {
    minPrice: null,
    maxPrice: null,
    minMeter: null,
    maxMeter: null,
    wc: null,
    bathrooms: null,
    is_studentResidence: null,
    tenants_gender: [],
    duration: [],
    selectedBadge: null,
    type: [],
    tenants: [],
    empty_rooms: [],
  };
  public meterSliderOptions: Options = {floor: 0, ceil: 10, hideLimitLabels: true, hidePointerLabels: true, enforceRange: false};
  public priceSliderOptions: Options = {floor: 0, ceil: 10, hideLimitLabels: true, hidePointerLabels: true, enforceRange: false};
  public slider = {
    meter: {
      max: 10,
      min: 0,
    },
    price: {
      max: 10,
      min: 0,
    }
  };
  private formattedFilters;
  public isPriceFocus: boolean = false;
  public isSurfaceFocus: boolean = false;
  public isGeneralFocus: boolean = false;
  private timeOut;
  public rangeLimit = {
    minPrice: null,
    maxPrice: null,
    minMeter: null,
    maxMeter: null,
  };
  @ViewChild('miniModale') private miniModale: ElementRef;

  constructor(
    private userService: UserService,
    private location: Location,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private r2: Renderer2,
    private helperService: HelperService
  ) {
  }

  ngOnDestroy() {
    this.listener$();
    clearTimeout(this.timeOut);
  }

  ngOnInit(): void {
    this.isMobile = this.userService.isMobileUser;
    this.setFilters();
  }

  ngAfterViewInit() {
    this.getUrlFilters();
    this.filterObj.emit(this.filters);
    this.submit('init');
  }

  public openFilter(element: string): void {
    if (this.displayedFilter === element) {
      this.displayedFilter = null;
      this.listener$();
    } else {
      this.displayedFilter = element;
      this.closeOnClickOutside();
    }
  }

  public clearFilter(): void {
    this.filters = {
      minPrice: null,
      maxPrice: null,
      minMeter: null,
      maxMeter: null,
      wc: null,
      bathrooms: null,
      is_studentResidence: null,
      selectedBadge: null,
      tenants_gender: [],
      duration: [],
      type: [],
      tenants: [],
      empty_rooms: [],
    };
    this.nbSubFilter = 0;
    this.filteredRooms.emit([this.rooms, this.sortValue]);
    this.filteredRoomsArray = this.rooms;
    this.sortValue = null;
    this.createFilterRoute();
    this.slider.price.max = this.priceSliderOptions.ceil;
    this.slider.price.min = this.priceSliderOptions.floor;
    this.slider.meter.max = this.meterSliderOptions.ceil;
    this.slider.meter.min = this.meterSliderOptions.floor;
  }

  public clearQuickFilter(type: string): void {
    if (type === 'Price') {
      this.filters['minPrice'] = null;
      this.filters['maxPrice'] = null;
      this.slider.price.max = this.priceSliderOptions.ceil;
      this.slider.price.min = this.priceSliderOptions.floor;
    } else {
      this.filters['minMeter'] = null;
      this.filters['maxMeter'] = null;
      this.slider.meter.max = this.meterSliderOptions.ceil;
      this.slider.meter.min = this.meterSliderOptions.floor;
    }
    this.filterRooms();
    this.submit();
  }

  private listener$ = () => {
  };

  private closeOnClickOutside(): void {
    this.listener$ = this.r2.listen('window', 'click', (e) => {
      if (this.miniModale && e.target !== this.miniModale.nativeElement && !e.target.classList.contains('isInside') && !e.target.classList.contains('ngx-slider-span') && !e.target.classList.contains('ngx-slider-bar')) {
        this.displayedFilter = null;
      }
    });
  }

  public filterRooms(): void {
    const x: { rooms: Property[], nbFilters: number } = FunctionsUtil.filterRooms(this.rooms, this.filters);
    this.nbSubFilter = x.nbFilters;
    this.filteredRoomsArray = x.rooms;
  }

  public submit(init?): void {
    this.filteredRooms.emit([this.filteredRoomsArray, this.sortValue]);
    if (!location.hash && !init) {
      this.createFilterRoute();
    }
  }

  public openModal(e) {
    if (!this.filteredRoomsArray) {
      this.filteredRoomsArray = this.rooms;
    }
    this.modalService.open(e, {size: 'lg'});
  }

  private createFilterRoute(): void {
    const url = '/accommodation/list/' + this.helperService.slugify(this.searchCity);
    const filtersProps = Object.keys(this.filters);
    let q = '';
    let f = false;
    filtersProps.forEach(element => {
      if (this.filters[element] && (!(this.filters[element] instanceof Array) || this.filters[element].length > 0)) {
        if (!f) {
          q = element + '=' + this.filters[element];
          f = true;
        } else {
          q = q + '&' + element + '=' + this.filters[element];
        }
      }

    });
    this.formattedFilters = q;
    this.location.replaceState(url, q);
  }

  public closeModale() {
    this.modalService.dismissAll();
  }

  public updateFromInputs(key: 'price' | 'meter', range: 'min' | 'max', event): void {
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(() => {
      let value = event;
      if (!value) {
        if (key === 'price') {
          if (range === 'min') {
            value = this.priceSliderOptions.floor;
          } else {
            value = this.priceSliderOptions.ceil;
          }
        } else {
          if (range === 'min') {
            value = this.meterSliderOptions.floor;
          } else {
            value = this.meterSliderOptions.ceil;
          }
        }
      }
      this.slider[key][range] = value;
      this.filterRooms();
      this.submit();
      this.filterObj.emit(this.filters);
    }, 380);
  }

  public updateFromSlider(key: 'meter' | 'price', e): void {
    if (key === 'price') {
      this.filters.minPrice = this.checkLimits(e.value, this.priceSliderOptions.floor);
      this.filters.maxPrice = this.checkLimits(e.highValue, this.priceSliderOptions.ceil);
    } else {
      this.filters.minMeter = this.checkLimits(e.value, this.meterSliderOptions.floor);
      this.filters.maxMeter = this.checkLimits(e.highValue, this.meterSliderOptions.ceil);
    }
    this.filterRooms();
    this.submit();
    this.filterObj.emit(this.filters);
  }

  private setFilters(): void {
    if (this.rooms && this.rooms.length > 0) {
      // Set le prix max & le prix min
      const sortByPrice = this.rooms.sort((a, b) => b.price - a.price);
      this.priceSliderOptions.ceil = sortByPrice[0].price;
      this.priceSliderOptions.floor = sortByPrice[sortByPrice.length - 1].price;
      this.slider.price.max = this.priceSliderOptions.ceil;
      this.slider.price.min = this.priceSliderOptions.floor;
      // Pour envoyer aux filtres - display only
      this.rangeLimit.maxPrice = this.priceSliderOptions.ceil;
      this.rangeLimit.minPrice = this.priceSliderOptions.floor;

      // Set le métrage max & le métrage minimum
      const sortByMeter = this.rooms.sort((a, b) => b.meter - a.meter);
      this.meterSliderOptions.ceil = sortByMeter[0].meter;
      this.meterSliderOptions.floor = sortByMeter[sortByMeter.length - 1].meter;
      this.slider.meter.max = this.meterSliderOptions.ceil;
      this.slider.meter.min = this.meterSliderOptions.floor;

      // Envoi les filtres, même vides, pour les alertes
      this.filterObj.emit(this.filters);
    }
  }

  private getUrlFilters(): void {
    this.route.queryParams.subscribe(data => {
      Object.keys(data).forEach(d => {
        if (d) {
          switch (d) {
            case 'price': {
              const split = data[d].split(' - ');
              if (split && split.length > 0) {
                if (parseInt(split[0])) {
                  this.filters['minPrice'] = parseInt(split[0]);
                }
                if (parseInt(split[1])) {
                  this.filters['maxPrice'] = parseInt(split[1]);
                }
              }
              break;
            }

            case 'surface': {
              const split = data[d].split(' - ');
              if (split && split.length > 0) {
                if (parseInt(split[0])) {
                  this.filters['minMeter'] = parseInt(split[0]);
                }
                if (parseInt(split[1])) {
                  this.filters['maxMeter'] = parseInt(split[1]);
                }
              }
              break;
            }

            case 'minMeter':
            case 'minPrice':
            case 'maxMeter':
            case 'maxPrice': {
              if (parseInt(data[d])) {
                this.filters[d] = parseInt(data[d]);
              }
              break;
            }

            case 'bathrooms':
            case 'wc': {
              this.filters[d] = data[d] === 'true';
              break;
            }

            case 'type':
            case 'tenants':
            case 'empty_rooms':
            case 'tenants_gender':
            case 'duration': {
              const f = data[d].split(',');
              this.filters[d] = f.filter(data => data.trim().length !== 0);
              break;
            }

            default : {
              this.filters[d] = data[d];
              break;
            }

          }
        }
      });
      this.slider.price.min = this.filters['minPrice'] ? this.filters['minPrice'] : this.priceSliderOptions.floor;
      this.slider.price.max = this.filters['maxPrice'] ? this.filters['maxPrice'] : this.priceSliderOptions.ceil;
      this.slider.meter.min = this.filters['minMeter'] ? this.filters['minMeter'] : this.meterSliderOptions.floor;
      this.slider.meter.max = this.filters['maxMeter'] ? this.filters['maxMeter'] : this.meterSliderOptions.ceil;
      this.filterRooms();
    });
  }

  private checkLimits(valueA, valueB): null | number {
    if (valueA !== valueB) {
      return valueA;
    }
    return null;
  }

  public updateSort(sortValue: string): void {
    if (sortValue === this.sortValue) {
      this.sortValue = 'none';
    }
  }

}
